import { createGlobalStyle } from 'styled-components'
import { DB_DARKBLUE } from 'constants/colors'

export const ChatBotStyles = createGlobalStyle`
  #chatbase-bubble-button {
    bottom: 45px !important;
    background-color: ${DB_DARKBLUE} !important;
    width: 60px !important;
    height: 60px !important;
    border-radius: 32.5px !important;
    border: 2px solid #ffffff !important;
    transition: background-color 0.3s, transform 0.3s !important;
  }

  #chatbase-bubble-button:hover {
    background-color: #0056b3 !important;
    transform: scale(1.1) !important;
  }
  
  #chatbase-bubble-button svg path {
    fill: #ffffff !important;
  }
`
